import React from "react";

const STEPS = [
  {
    word: "INTEGRATE",
    title: "Map what exists",
    desc: "We inventory every system, data source, and dependency already in play before proposing a single line of code.",
  },
  {
    word: "DESIGN",
    title: "Architect the connection",
    desc: "Data flows, APIs, and failure handling get designed and reviewed with your team before anything is built.",
  },
  {
    word: "BUILD",
    title: "Ship in working increments",
    desc: "Each integration point goes live independently and gets tested against production-like conditions.",
  },
  {
    word: "DELIVER",
    title: "Hand off and support",
    desc: "Documentation, runbooks, and an SLA — the system stays yours to operate, with us on call when it matters.",
  },
];

export default function Process() {
  return (
    <section id="process" className="section" style={{ background: "var(--paper-dim)" }}>
      <div className="container">
        <div className="row mb-5">
          <div className="col-lg-7">
            <div className="eyebrow mb-3">Our process</div>
            <h2 className="display-font mb-3" style={{ fontSize: "2.2rem", fontWeight: 600, color: "var(--navy-deep)" }}>
              The four stages, in order
            </h2>
            <p style={{ color: "#4b5b63", maxWidth: 580, lineHeight: 1.7 }}>
              The same sequence on every engagement, from a single API
              integration to a full platform rebuild.
            </p>
          </div>
        </div>

        <div className="row g-3">
          {STEPS.map((step) => (
            <div className="col-md-6 col-lg-3" key={step.word}>
              <div
                className="p-4 h-100"
                style={{
                  background: "#fff",
                  borderRadius: "var(--radius-md)",
                  border: "1px solid rgba(13,47,84,0.08)",
                  boxShadow: "var(--shadow-soft)",
                }}
              >
                <div className="mono-label mb-3" style={{ color: "var(--teal)" }}>
                  {step.word}
                </div>
                <h3 className="display-font mb-2" style={{ fontSize: "1.1rem", fontWeight: 600, color: "var(--navy-deep)" }}>
                  {step.title}
                </h3>
                <p style={{ color: "#4b5b63", fontSize: "0.9rem", lineHeight: 1.6, marginBottom: 0 }}>{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
